import React, { useRef, useContext, useState } from "react";
import html2canvas from "html2canvas";
import Receipt from "./index";
import { observeGetTransactionByID } from "../../../../database/helpers/pos_txns";

import { Box } from "@mui/material";
import { LanguageContext } from "../../../../context/LanguageContext";
import { UBButton } from "../../../../Libraries";
import withObservables from "@nozbe/with-observables";
import { catchError, of, switchMap } from "rxjs";
import { isDemoMode } from "../../../../utils/demoEnviornment";
import { toast } from "react-toastify";
import { checkConnection } from "../../../../printerConnection";
import { useAuthContext } from "../../../../context/AuthContext";
import useOrderSummary from "../../../../hooks/useOrderSummary";
import { camelCase, getPrint, sentenceCase } from "../../../../constants";
import { useSnackbar } from "../../../../context/SnackbarContext";
import { observeInvoicesById } from "../../../../database/helpers/invoice";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import styles from "./styles.module.css";
import { RECEIPT_CAPTURE_OPTIONS } from "../../../../utils";
import {
  BlackCheckIcon,
  DownloadIcon,
  TickIcon,
} from "../../../../assets/icons/icon";

const ReceiptPage = ({
  isPrintBtn = true,
  isDownloadBtn = true,
  isPrintIcon = true,
  isDownloadIcon = true,
  transaction,
  orders,
  customDowloadBtn,
  customPrintBtn,
  customUnpaidContent,
  invoiceStatus: invoiceStatusProp,
  handleDownloadLogEvent,
  handlePrintLogEvent,
  customerDetail,
  onInvoiceDownload,
  invoiceDownloadId = "invoice_download_btn",
  invoiceDownloadClassName,
  invoiceDownloadLogEvent,
  receiptDownloadId,
  receiptDownloadClassName,
  receiptDownloadTitle,
  receiptFileName = "Rupin Sale Receipt",
  receiptDownloadLogEvent,
  onRecordPayment,
  recordPaymentId,
  recordPaymentClassName,
  recordPaymentLogEvent,
  isNotShowReceipt,
  firstButtonTitle,
  otherCstmBtn,
  invoiceBtnTitle,
  downloadLoading,
  spinnerColor,
  hideActionIcons = false,
  setIsReceiptLoading,
  actionVariant = "default",
}) => {
  const receiptRef = useRef();
  const [I18n] = useContext(LanguageContext);
  const [isLoadingDownload, setIsLoadingDownload] = useState(false);
  const [isPrintLoading, setIsPrintLoading] = useState(false);
  const { business } = useAuthContext();
  const { showSnackbar } = useSnackbar();
  const tempTransaction = transaction?.length ? transaction[0] : {};
  const invoiceStatus =
    invoiceStatusProp ??
    tempTransaction?.status ??
    tempTransaction?._raw?.status;
  const { subTotalAmount, totalAmount, totalDiscountPerItem } = useOrderSummary(
    {
      sale_order_line: orders,
      orderDiscount: tempTransaction?._raw?.discount,
      orderDiscountMethod: tempTransaction?._raw?.discount_unit,
      orderTax: tempTransaction?._raw?.tax_rate,
      orderTaxMethod: tempTransaction?._raw?.tax_type,
    },
  );

  const handlePrint = () => {
    setIsPrintLoading(true);
    checkConnection(business)
      .then((printers) => {
        if (printers[0] === "connected") {
          let dataForPrint = {
            amount: totalAmount,
            subTotal: subTotalAmount - totalDiscountPerItem,
            date: new Date(),
            customer: customerDetail,
            items: orders,
            printer: business.printer,
            business,
          };
          getPrint(dataForPrint, true);
          handlePrintLogEvent?.();
        } else if (printers[0] == "off" || printers[0] === "not connected") {
          showSnackbar({
            message: "Printer not connected",
            severity: "error",
            icon: "",
          });
        } else if (printers[0] === "not exist") {
          showSnackbar({
            message: "Printer not exist",
            severity: "error",
            icon: "",
          });
        }
      })
      .catch((error) => {
        if (error === "not connected") {
          showSnackbar({
            message: "Printer not connected",
            severity: "error",
            icon: "",
          });
        }
      })
      .finally(() => setIsPrintLoading(false));
  };
  const handleDownloadJpg = () => {
    if (setIsReceiptLoading) {
      setIsReceiptLoading(true);
    } else {
      setIsLoadingDownload(true);
    }

    if (isDemoMode()) {
      toast.info(
        <>
          Want to download this report?{" "}
          <a
            href="https://web.udhaar.pk/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#030404ff", textDecoration: "underline" }}
          >
            Create your account
          </a>
        </>,
      );
      return null;
    }

    const receipt = receiptRef.current;

    html2canvas(receipt, RECEIPT_CAPTURE_OPTIONS)
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 1.0);
        const link = document.createElement("a");
        link.href = imgData;
        link.download = `${receiptFileName}.jpg`;
        link.click();
        handleReceiptDownloadComplete();
      })
      .catch(() => {})
      .finally(() => {
        if (setIsReceiptLoading) {
          setIsReceiptLoading(false);
        } else {
          setIsLoadingDownload(false);
        }
      });
  };
  const handleReceiptDownloadComplete = () => {
    handleDownloadLogEvent?.();
    if (receiptDownloadLogEvent) {
      triggerLogEvent(analytics, receiptDownloadLogEvent);
    }
  };

  const handleInvoiceDownloadClick = () => {
    onInvoiceDownload?.();
    if (invoiceDownloadLogEvent) {
      triggerLogEvent(analytics, invoiceDownloadLogEvent);
    }
  };

  const handleRecordPaymentClick = () => {
    onRecordPayment?.();
    if (recordPaymentLogEvent) {
      triggerLogEvent(analytics, recordPaymentLogEvent);
    }
  };

  const isSuccessActions = actionVariant === "success";
  const getRowActionBtnClass = (...extraClasses) =>
    [
      styles.rowActionBtn,
      styles.textCapitalizeFirstLetter,
      isSuccessActions && styles.successActionBtn,
      ...extraClasses,
    ]
      .filter(Boolean)
      .join(" ");

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Receipt ref={receiptRef} orders={orders} transaction={transaction} />
      </div>
      <Box
        className={`${styles.actionsBox} ${
          actionVariant === "success" ? styles.actionsBoxSuccess : ""
        } actionsBox width100`}
      >
        {invoiceStatus?.toLowerCase() !== "paid" &&
          (onRecordPayment ? (
            <UBButton
              id={recordPaymentId ?? "record_pay_btn_detail_view"}
              className={getRowActionBtnClass()}
              title={firstButtonTitle ?? I18n.record_payment}
              iconComponent={<TickIcon width={16} height={16} />}
              onClick={handleRecordPaymentClick}
            />
          ) : (
            customUnpaidContent
          ))}
        {(customPrintBtn || isPrintBtn) && (
          <UBButton
            id="print_recipt"
            iconComponent={
              !hideActionIcons && !customPrintBtn && isPrintIcon && (
                <DownloadIcon />
              )
            }
            title={customPrintBtn ?? I18n[sentenceCase("print_recipt")]}
            className={getRowActionBtnClass(!isSuccessActions && "width100")}
            loading={isPrintLoading}
            spinnerColor={spinnerColor}
            onClick={handlePrint}
            disabled={isPrintLoading}
          />
        )}
        {!isNotShowReceipt &&
          (customDowloadBtn || receiptDownloadTitle || isDownloadBtn) && (
            <UBButton
              id={
                receiptDownloadTitle && !customDowloadBtn
                  ? (receiptDownloadId ?? "download_recipt")
                  : "download_recipt"
              }
              iconComponent={!hideActionIcons && isDownloadIcon && <DownloadIcon />}
              title={receiptDownloadTitle ?? I18n["download_recipt"]}
              className={getRowActionBtnClass("rowActionBtn")}
              loading={isLoadingDownload}          
              spinnerColor={spinnerColor}
              onClick={handleDownloadJpg}
              disabled={isLoadingDownload}
            />
          )}
        {onInvoiceDownload && (
          <UBButton
            id={invoiceDownloadId}
            iconComponent={
              !hideActionIcons && <DownloadIcon id="download_black_btn" />
            }
            title={invoiceBtnTitle || I18n.invoice}
            className={getRowActionBtnClass(
              "invoiceDownloadBtn",
              downloadLoading && !isSuccessActions && "invoiceLoader",
            )}
            onClick={handleInvoiceDownloadClick}
            loading={downloadLoading}
            spinnerColor={spinnerColor}
          />
        )}
        {React.Children.map(otherCstmBtn, (btn) =>
          btn
            ? React.cloneElement(btn, {
                className: getRowActionBtnClass(btn.props?.className),
              })
            : null,
        )}
      </Box>
    </div>
  );
};

const enhance = withObservables(
  ["transactionId", "invoiceId"],
  ({ transactionId, invoiceId }) => {
    const activeId = transactionId || invoiceId;

    if (!activeId) {
      return {
        record: of([]),
        customerDetail: of({}),
        orders: of([]),
      };
    }

    const source$ = transactionId
      ? observeGetTransactionByID(activeId)
      : observeInvoicesById(activeId);

    const safeSource$ = source$ ?? of([]);

    return {
      transaction: safeSource$,

      customerDetail: safeSource$.pipe(
        switchMap((records = []) => {
          if (!Array.isArray(records) || records.length === 0) {
            return of({});
          }

          return records[0]?.customer?.observe?.() ?? of({});
        }),
        catchError(() => of({})),
      ),

      orders: safeSource$.pipe(
        switchMap((records = []) => {
          if (!Array.isArray(records) || records.length === 0) {
            return of([]);
          }

          return records[0]?.orders?.observe?.() ?? of([]);
        }),
        catchError(() => of([])),
      ),
    };
  },
);

export default enhance(ReceiptPage);
